import React from 'react';
import './index.css';

import cfgImage from './imgs/configimg.png';
import htmlImage from './imgs/htmlreportimg.png';

import logAnalyzerZip from './files/MRPLogAnalyzer.zip'

function Utilities() {
  return (
    <section className="detail-page">
      <div className="detail-container">
        <h1 className="detail-title">
          Free <span className="detail-gradient">Utilities</span>
        </h1>

        <div className="detail-intro">
          <p>
            Tools built from real-world experience to help you manage and understand your Epicor environment.
          </p>
        </div>

        {/* ERP Schema Visualizer */}
        <div className="detail-card utility-card-wide">
          <div className="detail-card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
              <circle cx="12" cy="12" r="10"/>
              <line x1="2" y1="12" x2="22" y2="12"/>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
            </svg>
          </div>
          <h2 className="detail-card-title">ERP Schema Visualizer</h2>
          <p className="detail-card-desc">
            "Is there a schema map of Epicor?" I think we have all asked this question at some point. The typical answer is no. It's just too sprawling.
          </p>
          <p className="detail-card-desc">That is changing. I present my ERP Schema Visualizer. Visualize tables and relationships. Find connections between multiple tables.</p>

          <ul className="detail-list">
            <li>The connections to Company aren't shown because if they did, it would just be a gazillion lines pointing to that table.</li>
            <li>Not all joins are shown — only the ones defined within the Epicor framework are shown (think about the ones that auto connect on a BAQ).</li>
          </ul>

          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            <a href="/schema-visualizer" className="pricing-cta-btn">Launch ERP Schema Visualizer</a>
          </div>
        </div>

        {/* MRP Log Aggregator */}
        <div className="detail-card detail-card-accent utility-card-wide" style={{ marginTop: '32px' }}>
          <div className="detail-card-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
              <line x1="16" y1="13" x2="8" y2="13"/>
              <line x1="16" y1="17" x2="8" y2="17"/>
              <polyline points="10 9 9 9 8 9"/>
            </svg>
          </div>
          <h2 className="detail-card-title">MRP Log Aggregator &amp; Purge Utility</h2>
          <p className="detail-card-desc">
            Aggregate errors and exceptions from your Epicor MRP logs.
            <strong> OnPrem only</strong> (though with enough interest I could probably make a Cloud version).
          </p>
          <p className="detail-card-desc">
            <strong>Bonus</strong> — purge old log files from your EpicorData folders.
          </p>
          <p className="detail-card-desc">
            If you have multiple environments and/or multiple companies, sometimes it can be a pain to review piles of very long log files
            looking for the needle in the haystack. This solution will take a list of log files to monitor. Each time it is ran, it will
            generate an HTML report of the issues. There is a navigatable Table of Contents.
          </p>

          <div className="utility-images">
            <div className="utility-img-wrap">
              <h3 className="utility-img-label">Resulting HTML file:</h3>
              <img src={htmlImage} alt="HTML Output Example" className="utility-img"/>
            </div>
            <div className="utility-img-wrap">
              <h3 className="utility-img-label">Configuration:</h3>
              <img src={cfgImage} alt="App.Config Example" className="utility-img"/>
            </div>
          </div>

          <div className="utility-details">
            <div>
              <h3 className="utility-section-title">Output</h3>
              <p className="detail-card-desc"><code className="utility-code">Error_log.html</code>, generated in this application's folder. This overwrites with each run.</p>
            </div>
            <div>
              <h3 className="utility-section-title">Requirements</h3>
              <ul className="detail-list">
                <li>Windows</li>
                <li>.NET8 — <a href="https://dotnet.microsoft.com/en-us/download/dotnet/8.0" className="contact-link">download</a></li>
              </ul>
            </div>
            <div>
              <h3 className="utility-section-title">Configuration Keys</h3>
              <ul className="detail-list">
                <li><code className="utility-code">LogFilePaths</code> — Comma separated list of log files to review</li>
                <li><code className="utility-code">LogDirPurgeDays</code> — How many days worth of logs to keep</li>
                <li><code className="utility-code">LogDirsToPurge</code> — Comma separated list of directories to purge old .log files from</li>
              </ul>
            </div>
          </div>

          <div className="utility-warning">
            <strong>Note:</strong> The directories/files you are trying to access must be reachable. The user account you run this with will determine what permissions are used.
          </div>

          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            <a href={logAnalyzerZip} className="pricing-cta-btn" download>Download MRP Log Aggregator</a>
            <p className="utility-hint">Unzip to desired directory. Modify config file. Run MRPLogAnalyzer.exe</p>
            <p className="utility-disclaimer">No warranties. Use at your own risk!</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Utilities;
